export default __webpack_public_path__ + "static/media/FXS.5dbab8f2.png";